import { useEffect, useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { showAlert } from "@utils/Alert";
import { ProviderApi, ProviderDataType } from "@/api/ProviderApi";

const ProviderIndex = () => {
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);

  useEffect(() => {
  }, []);

  const deleteRecord = async (id: string) => {
    const { errors } = await ProviderApi.delete(id);
    if (errors?.length) {
      showAlert('danger', 'El Provedor no puedo ser eliminado');
    } else {
      showAlert('success', 'El Provedor fue eliminado correctamente');
    }
    modelRef.current?.refetch();
  }

  return (
    <PageContainer
      title="Lista de Provedores"
      backUrl="/user/dashboard"
      primaryActions={[
        {
          onClick: () => {
            navigate('/user/provider')
          },
          actionTitle: "Nuevo",
          color: "success"
        }
      ]}
      secondaryActions={[
        {
          actionTitle: "Ordenes de Compra",
          href: "/user/providerorders"
        },
        {
          actionTitle: "Importar Proveedores",
          href: "/user/providers/import"
        },
        {
          actionTitle: "Reportes",
          href: "/user/dashboard-providers"
        }
      ]}
    >
      <ModelIndex<ProviderDataType>
        ref={modelRef}
        meiliConfig={{
          index: "providers",
          sort: ["nombre:asc"]
        }}
        fetchData={(filters, token, limit) => ProviderApi.fetchAll(filters, token, limit, null, { noCache: true })}
        filterProps={[
          {
            key: "codigo",
            filterType: "eq",
            type: "number"
          },
          {
            key: "nombre",
            filterType: "contains"
          },
          {
            key: "nombre_comercial",
            placeholder: "Nombre Comercial",
            filterType: "contains"
          },
          {
            key: "telefono1",
            filterType: "contains"
          },
          {
            key: "telefono2",
            filterType: "contains"
          },
          {
            key: "email",
            filterType: "contains"
          }
        ]}
        primaryProperties={[
          {
            key: "codigo",
            highlighted: true
          },
          {
            key: "nombre",
            alignment: "Start"
          },
        ]}
        primaryPropertiesSizing={
          [
            { sm: "1", xs: "3" },
            { sm: "11", md: "9" }
          ]
        }
        secondaryProperties={[
          {
            key: "nombre_comercial",
            title: "Nombre Comercial",
          },
          {
            key: "telefono1",
            title: "Tel 1",
          },
          {
            key: "telefono2",
            title: "Tel 2",
          },
          {
            key: "email",
            title: "Email"
          }
        ]}
        listActions={[
          {
            href: "/user/provider/{:id}",
            actionTitle: "Editar Provedor",
            iconProps: { icon: faEdit }
          },
          {
            actionTitle: "Eliminar Provedor",
            iconProps: { icon: faTrash },
            needConfirm: true,
            confirmProps: {
              title: "Eliminar Provedor",
              confirmMessage: "¿Seguro que desea eliminar este Provedor?",
              confirmBtnText: "Eliminar"
            },
            onClick: (id: string) => { deleteRecord(id) }
          }
        ]}
      >
      </ModelIndex>

    </PageContainer >
  );
}

export default ProviderIndex;
